import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BYPASS_LOG } from '../interceptors/http.error.interceptor';


import {
  LoginModel,
  ForgotPasswordModel,
  ResetPasswordModel,
  ChangePasswordModel,
} from '../models/auth.model';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminAuthService {
  public BACKEND_HOST = environment.url + '/admin';

  constructor(private http: HttpClient) {}

  // log in
  login(credential: LoginModel): any {
    return this.http.post(`${this.BACKEND_HOST}/login`, credential).pipe(
      map((res: any) => {
        return res.data;
      }),
    );
  }

  // log in
  verifiyLogin(credential: LoginModel): any {
    return this.http
      .post(`${this.BACKEND_HOST}/login-verification`, credential,{withCredentials:true})
      .pipe(
        map((res: any) => {
          res = res.data;

          if (res.user) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(res.user));
            localStorage.setItem('role', res.user.role);
            // this.currentUserSubject.next(res.user);
            if (res.user.loginConfig) {
              localStorage.setItem(
                'loginConfig',
                JSON.stringify(res.user.loginConfig),
              );
            }
          }
          return res;
        }),
      );
  }

  // async isAdminCheck(): Promise<boolean> {
  //   console.log(this.currentUserSubject.value);
  //   await this.currentUser.subscribe(x => {
  //     ['admin', 'care-member', 'developer'].includes(x.role)
  //   });

  //   return this.isLoggedIn() && ['admin', 'care-member', 'developer'].includes(this.currentUserSubject.value.role);
  // }

  // log out
  logout(): Observable<void> {
    localStorage.clear();
    return this.http.post<void>(`${this.BACKEND_HOST}/logout`, {context: new HttpContext().set(BYPASS_LOG, true)});
  }

  // ResetPassword
  forgetPassword(credential: ForgotPasswordModel): any {
    return this.http
      .post<ResetPasswordModel>(
        `${this.BACKEND_HOST}/forget-password`,
        credential,
      )
      .pipe(
        map((res: any) => {
          return res.data;
        }),
      );
  }

  // ResetPassword
  initialForgetPassword(credential: ForgotPasswordModel): any {
    return this.http
      .post<ResetPasswordModel>(
        `${this.BACKEND_HOST}/forget-password-get-code-via`,
        credential,
      )
      .pipe(
        map((res: any) => {
          return res.data;
        }),
      );
  }

  // verifiyResetPasswordCode
  verifiyResetPasswordCode(credential: ResetPasswordModel): any {
    return this.http
      .post<ResetPasswordModel>(
        `${this.BACKEND_HOST}/verify-password-reset-code`,
        credential,
      )
      .pipe(
        map((res: any) => {
          return res.data;
        }),
      );
  }

  // resetPassword
  resetPassword(credential: ResetPasswordModel): any {
    return this.http
      .post<ResetPasswordModel>(
        `${this.BACKEND_HOST}/reset-password`,
        credential,
      )
      .pipe(
        map((res: any) => {
    
          return res.data;
        }),
      );
  }

  // changePassword
  changePassword(credential: ChangePasswordModel): any {
    return this.http
      .put<ChangePasswordModel>(
        `${this.BACKEND_HOST}/change-password`,
        credential,
      )
      .pipe(
        map((res: any) => {
          return res.data;
        }),
      );
  }

  isLoggedIn(): Observable<boolean> {
      return this.http.get<{authenticated:boolean}>(`${this.BACKEND_HOST}/check-session`, {context: new HttpContext().set(BYPASS_LOG, true)})
        .pipe(
          map(response => {
            return response.authenticated;
          })
        );
    
    
  }

  canResetPassword():boolean{
    return !!localStorage.getItem('token');
  }

  hasResetPassword(): boolean {
    let loginConfig: any = localStorage.getItem('loginConfig');
    loginConfig = loginConfig ? JSON.parse(loginConfig) : null;
    if (loginConfig && loginConfig.hasResetPassword === true) {
      return true;
    } else {
      return false;
    }
  }
}
